<div class="modal fade show" style="display: block;" tabindex="-1" role="dialog">
  <div class="modal-dialog modal-dialog-centered" role="document">
    <div class="modal-content">
      <div class="modal-body text-center">
        <i class="fa fa-exclamation-triangle text-warning"></i>
        <h6 class="mt-3" *ngIf="daysRemaining > 0">Your password will expire in {{daysRemaining}} day{{daysRemaining !== 1 ? 's' : ''}}</h6>
        <h6 class="mt-3" *ngIf="daysRemaining === 0">Your password expires today.</h6>
        <p class="text-muted">Please change your password to continue using the portal.</p>
      </div>
      <div class="modal-footer justify-content-center">
        <button type="button" class="btn btn-primary mr-2 border-radius-10" (click)="onChangePassword()">
          Change Password
        </button>
        <button type="button" class="btn btn-secondary border-radius-10" (click)="onRemindLater()">
          Remind me later
        </button>
      </div>
    </div>
  </div>
</div>
<div class="modal-backdrop fade show"></div>